import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { FormLabel, Stack, Typography } from '@mui/material';
import CustomIconButton from 'common/components/CustomIconButton';
import CustomTooltip from 'common/components/CustomTooltip';
import useFlexBoxStyles from 'common/flexBox';
import useOnliveStyles from 'common/onliveStyles';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import DateOverrideItem from './DateOverrideItem';

const DateOverride = (props) => {
    const { fields, handleFieldChange } = props;

    const { t } = useTranslation();
    const { classes: flexBox, cx } = useFlexBoxStyles();
    const { classes: onlive } = useOnliveStyles();
    const dateOverrides = fields?.overrides;

    const handleSubmit = (data) => {
        const newOverrides = { ...dateOverrides };
        newOverrides[data.date] = data.overrides;
        handleChange(newOverrides);
    };

    const handleDelete = (key) => {
        const newOverrides = { ...dateOverrides };
        if (dateOverrides.hasOwnProperty(key)) {
            delete newOverrides[key];
        }
        handleChange(newOverrides);
    };

    const handleChange = (newOverrides) => {
        handleFieldChange({
            target: {
                name: 'overrides',
                value: newOverrides,
            },
        });
    };

    return (
        <Stack direction="column" className={flexBox.paddingTop2}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <FormLabel>{t('calendar.addADateOverride').toUpperCase()}</FormLabel>
            </Stack>
            <Stack direction="column" spacing={2}>
                <DateOverrideItem onSubmit={handleSubmit} />
                {Object.keys(dateOverrides)?.map((key) => (
                    <Stack
                        direction="row"
                        key={key}
                        justifyContent="space-between"
                        alignItems="center"
                        className={cx(flexBox.borderRadius1, onlive.borderSecondaryDark, flexBox.padding1)}
                    >
                        <Typography variant="subtitle2" fontWeight={400}>
                            {moment(key).format('DD / MM / YYYY')}
                        </Typography>

                        <Stack direction="column" key={key}>
                            {dateOverrides[key]?.map((hour, idx) => (
                                <Stack key={idx} direction="row" spacing={2}>
                                    <Typography variant="subtitle2" fontWeight={400}>
                                        {hour.startTime}
                                    </Typography>
                                    <Typography variant="subtitle2" fontWeight={400}>
                                        {t('services.form.dateTo')}
                                    </Typography>
                                    <Typography variant="subtitle2" fontWeight={400}>
                                        {hour.endTime}
                                    </Typography>
                                </Stack>
                            ))}
                        </Stack>

                        <CustomTooltip arrow title={t('contact.remove')} placement={'bottom'}>
                            <CustomIconButton
                                aria-label="delete"
                                color="error"
                                onClick={() => handleDelete(key)}
                                size="small"
                            >
                                <DeleteOutlineOutlinedIcon />
                            </CustomIconButton>
                        </CustomTooltip>
                    </Stack>
                ))}
            </Stack>
        </Stack>
    );
};

export default DateOverride;
